import React from 'react'

const BaseBlock = ({t = 4, b = 4, ...props}) => {
  return <div className={`mt-${t} mb-${b}`} {...props} />
}

export default BaseBlock
